import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import SearchCity from './SearchCity';
import Weather from './Weather';
import { apiKey } from './Constant';
import './mm.css';
import Footer from '../Footer/Footer';
import Head from '../Head/Head';

const Main = () => {

    const [city, setCity] = useState('');

    const [weatherInfo, setWeatherInfo] = useState([]);

    useEffect(() => {
        if (city) {
            fetch(`https://api.openweathermap.org/data/2.5/forecast?q=${city}&cnt=5&appid=${apiKey}`)
                .then(res => res.json())
                .then(res =>
                    // console.log(res))
                    setWeatherInfo(res.list.map(lst => {
                        return {
                            min: lst.main.temp_min,
                            max: lst.main.temp_max,
                            humidity: lst.main.humidity,
                            weather: lst.weather[0]?.description,
                            weatherIcon: lst.weather[0]?.icon
                        }
                    }))
                )
        }

    }, [city]);

    // useEffect(() => {
    //     console.log("weatherInfo", cityInfo)
    // }, [cityInfo])

    // useEffect(() => {
    //     console.log("weatherInfo", weatherInfo)
    // }, [weatherInfo])

    return (
        <div className="bg">
            <Head></Head>
            <br />
            <div style={{marginTop:"100px"}} className="container text-center">
                <SearchCity
                    onCityFound={cityInfo => {
                        setCity(cityInfo.city);
                    }}
                />
            </div>
            <div className="main container">

                {!!weatherInfo && weatherInfo.map((weather, index) => (<div className="day" key={index}>
                    <Weather min={weather.min} max={weather.max} humidity={weather.humidity} weather={weather.weather} weatherIcon={weather.weatherIcon} />
                </div>))}
            </div>
            <div>
                <Footer/>
                <br />
            </div>

        </div>
    );
};

export default Main;